/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteAwsIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteAwsIamCredentialRequest = {
  /**
   * The ID of the credential to delete.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteAwsIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAwsIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  DeleteAwsIamCredentialSecurity$Outbound,
  DeleteAwsIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteAwsIamCredentialSecurityToJSON(
  deleteAwsIamCredentialSecurity: DeleteAwsIamCredentialSecurity,
): string {
  return JSON.stringify(
    DeleteAwsIamCredentialSecurity$outboundSchema.parse(
      deleteAwsIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type DeleteAwsIamCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteAwsIamCredentialRequest$outboundSchema: z.ZodMiniType<
  DeleteAwsIamCredentialRequest$Outbound,
  DeleteAwsIamCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function deleteAwsIamCredentialRequestToJSON(
  deleteAwsIamCredentialRequest: DeleteAwsIamCredentialRequest,
): string {
  return JSON.stringify(
    DeleteAwsIamCredentialRequest$outboundSchema.parse(
      deleteAwsIamCredentialRequest,
    ),
  );
}
